import builder from '../builder';
import CalendarLock1 from '../../streamline-icons/light/calendar-lock-1.svg';

export default builder('IconCalendarLock1Light', CalendarLock1);
